import React, { useEffect, useState } from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Grid,
    Hidden,
    Typography,
} from '@material-ui/core';
import { Modal, ModalBody } from 'reactstrap';
import { useDisplayPINPUKStyle } from '../css/useDisplayPINPUKStyle';
import axios from 'axios';
import { ArrowBackIcon } from '../../sharedcomponents/inputs/svg-icons/CustomSvgIcons';

function MyEirDisplayUAN({ bbuan, vobbuan }) {
    const [isopen, setIsopen] = useState(false);
    async function toggle() {
        setIsopen(!isopen);
        if (!isopen) {
            await fetch(
                `https://m.rtm.eir.ie/webApp/myeirtriggers?t=uan&ac=${sessionStorage.getItem(
                    'LoggedinUserAccountID'
                )}`,
                {
                    method: 'GET',
                    mode: 'no-cors',
                }
            );
            /* await axios.get(
                `https://m.rtm.eir.ie/webApp/myeirtriggers?t=uan&ac=${sessionStorage.getItem(
                    'LoggedinUserAccountID'
                )}`
            ); */
        }
    }
    const classes = useDisplayPINPUKStyle();

    return (
        <React.Fragment>
            <div className='contracts-topic-change' onClick={toggle}>
                <Typography className='contracts-see-my-uan'>See your UAN</Typography>
            </div>
            <Modal
                className='pinPuk-main'
                // wrapClassName="pinPuk-wrap"
                wrapClassName={classes.PinPukWrapper}
                modalClassName='pinPuk-modal'
                backdropClassName='pinPuk-backdrop'
                contentClassName='pinPuk-content'
                isOpen={isopen}
                toggle={toggle}
                centered
            >
                <ModalBody className='pinPuk-body'>
                    <div className='pinPuk-body-header'>
                        <ArrowBackIcon className='pinPuk-header-back-icon' onClick={toggle} />
                        <div className='pinPuk-header-text'>Universal Account Number</div>
                    </div>
                    <div className='pinPuk-body-content'>
                        {bbuan != null ? (
                            <div className='pinPuk-pin-info'>
                                <div className='pinPuk-body-content-header'>Your broadband UAN</div>
                                <div className='pinPuk-body-content-info'>{bbuan}</div>
                            </div>
                        ) : (
                            ''
                        )}
                        {vobbuan != null ? (
                            <div className='pinPuk-puk-info'>
                                <div className='pinPuk-body-content-header'>Your landline UAN</div>
                                <div className='pinPuk-body-content-info'>{vobbuan}</div>
                            </div>
                        ) : (
                            ''
                        )}
                        <div className='pinPuk-pin-description'>
                            <div className='pinPuk-body-content-header'>What is my UAN?</div>
                            <div className='pinPuk-body-content-description'>
                                UAN stands for Universal Account Number, which is an eight-digit
                                account number that is used to port telephone numbers between phone
                                companies.
                                <br></br>
                                <br></br>
                                The UAN is an importnat piece of information which is used by
                                service providers to confirm that the person enquiring about the
                                customer account is customer concerned. This information is also
                                required by service providers when a customer wishes to change
                                service provider.
                            </div>
                        </div>
                    </div>
                    <div className='pinPuk-body-footer'>
                        <button className='pinPuk-body-footer-cta' onClick={toggle}>
                            Close
                        </button>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}

export default MyEirDisplayUAN;
